import api from '@/lib/services/general.service'
import { toast } from 'vue3-toastify';
import { toRaw } from 'vue';

let _timelineCountTimer = null;
let _contactsFilterTimer = null;

function scheduleFetchTimelineCount(dispatch) {
  clearTimeout(_timelineCountTimer);
  _timelineCountTimer = setTimeout(() => dispatch('timeline/fetchTimelineCount', null, { root: true }), 10000);
}

function scheduleFetchContactsFilter(dispatch) {
  clearTimeout(_contactsFilterTimer);
  _contactsFilterTimer = setTimeout(() => dispatch('timeline/fetchContactsFilter', null, { root: true }), 10000);
}

export const state = {
  show: true,
  // Reported by the SidePanel component so the layout can pad the centre content
  // (the panel overlays; content must not slide under it).
  panelOpen: false,
  panelWidth: parseInt(localStorage.getItem('globalTimelineWidth') || '380', 10),
  content: '',
  id: null,
  title: '',
  defaultTab: 'search',
  tabs: [{ id: 'default', type: 'default', title: 'Global timeline', closeable: false }],
  activeTabId: 'default',
  expandedEntityId: null,
  contact: null,
  timeline: null,
  timelines: {
    items: [],
    index: 0,
    totalCount: 0,
    totalPages: 0,
    hasPreviousPage: 0,
    hasNextPage: 0,
  },
  timelinesIsLoading: true,
  timelineIsLoading: true,
  requestData: {
    page: 1,
    pageSize: parseInt(localStorage.getItem('pageSize_contactFilter') || '50', 10),
    order: 1,
    contactId: null,
    search: '',
  },
  entityId: null,
  emailAnalyses: {},
  emailAnalysisLoading: false,
  activeAnalysisTimelineId: null,
  autoAnalyzeTimelineId: null,
  activeEmailBody: null,
  chatLoading: false,
  chatMessages: {},
  contactAll: null,
  contactAllIsLoading: false,
  contactAllRequestData: {
    page: 1,
    pageSize: 50,
    order: 1,
    search: '',
  },
}

export const getters = {
  tabs: x => x.tabs,
  activeTabId: x => x.activeTabId,
  activeTabExpandedEmailId: x => x.tabs.find(t => t.id === x.activeTabId)?.expandedEmailId || null,
  show: x => x.show,
  panelOpen: x => x.panelOpen,
  panelWidth: x => x.panelWidth,
  content: x => x.content,
  id: x => x.id,
  entityId: x => x.entityId,
  title: x => x.title,
  defaultTab: x => x.defaultTab,
  expandedEntityId: x => x.expandedEntityId,
  contact: x => x.contact,
  timeline: x => x.timeline,
  timelines: x => x.timelines,
  isLoading: x => x.timelinesIsLoading,
  timelineIsLoading: x => x.timelineIsLoading,
  requestData: x => x.requestData,
  emailAnalyses: x => x.emailAnalyses,
  emailAnalysisLoading: x => x.emailAnalysisLoading,
  activeAnalysisTimelineId: x => x.activeAnalysisTimelineId,
  autoAnalyzeTimelineId: x => x.autoAnalyzeTimelineId,
  activeEmailBody: x => x.activeEmailBody,
  chatLoading: x => x.chatLoading,
  chatMessages: x => x.chatMessages,
  contactAll: x => x.contactAll,
  contactAllIsLoading: x => x.contactAllIsLoading,
  contactAllRequestData: x => x.contactAllRequestData,
}

export const actions = {
  setPanelOpen({ commit }, val) {
    commit('SET_PANEL_OPEN', val)
  },
  setPanelWidth({ commit }, val) {
    commit('SET_PANEL_WIDTH', val)
  },
  async fetchContactAll({ commit, state }, { id }) {
    commit("SET_CONTACT_ALL_LOADING", true)
    return await api.get(`timeline/contact/${id}/all`, state.contactAllRequestData).then(response => {
      if (response) {
        commit("SET_CONTACT_ALL", response.data)
        commit("SET_CONTACT_ALL_LOADING", false)
      }
      return false;
    });
  },
  contactAllPageSizeChange({ commit }, { pageSize }) {
    commit("SET_CONTACT_ALL_PAGE_SIZE", pageSize)
  },
  contactAllPageChange({ commit }, { page }) {
    commit("SET_CONTACT_ALL_PAGE", page)
  },
  contactAllPageOrderChange({ commit }, { pageOrder }) {
    commit("SET_CONTACT_ALL_PAGE_ORDER", pageOrder)
  },
  collapse({ commit }, request) {
    commit("SET_ISCOLLAPSE", request);
  },
  collapseAll({ commit }) {
    commit("SET_ISCOLLAPSE_TRUE_All");
  },
  async showSidePanel({ commit, state }, payload) {
    if (payload && payload.id !== undefined) {
      if (state.id === payload.id && state.show) {
        commit("HIDE_SIDE_PANEL")
        commit("SET_ID", null)
      } else {
        commit("SHOW_SIDE_PANEL")
        commit("SET_ID", payload.id)
      }
    } else {
      commit("SHOW_SIDE_PANEL")
    }
  },
  openSidePanel({ commit }, payload) {
    commit("SHOW_SIDE_PANEL")
    if (payload && payload.id !== undefined) {
      commit("SET_ID", payload.id)
    }
  },
  closeSidePanel({ commit }) {
    commit("HIDE_SIDE_PANEL")
    commit("SET_ID", null)
  },
  toggleShow({ commit, state }) {
    if (state.show) {
      commit("HIDE_SIDE_PANEL")
    } else {
      commit("SHOW_SIDE_PANEL")
    }
  },
  setExpandedEntityId({ commit }, entityId) {
    commit("SET_EXPANDED_ENTITY_ID", entityId)
  },
  pageSizeChange({ commit }, { pageSize }) {
    commit("CHANGE_PAGE_SIZE", pageSize)
  },
  addTaskIntoTimeline({ commit }, task) {
    commit("ADD_TASK", task);
  },
  editTaskTimeline({ commit }, task) {
    commit("EDIT_TASK", task);
  },
  addNoteIntoTimeline({ commit }, note) {
    commit("ADD_NOTE", note);
  },
  addEmailIntoTimeline({ commit }, email) {
    commit("ADD_EMAIL", email);
  },
  addEventIntoTimeline({ commit }, event) {
    commit("ADD_EVENT", event);
  },
  editNoteTimeline({ commit }, note) {
    commit("EDIT_NOTE", note);
  },
  editEventTimeline({ commit }, event) {
    commit("EDIT_EVENT", event);
  },
  pageChange({ commit }, { page }) {
    commit("CHANGE_PAGE", page)
  },
  pageOrderChange({ commit }, { pageOrder }) {
    commit("CHANGE_PAGE_ORDER", pageOrder)
  },
  search({ commit }, { search }) {
    commit("SEARCH", search)
  },
  resetSearch({ commit }) {
    commit("RESET_SEARCH")
  },
  setEntityId({ commit }, entityId) {
    commit("SET_ENTITY_ID", entityId)
  },
  deleteTimelineItems({ commit }, request) {
    commit("DELETE_TIMELINE_ITEMS", request);
  },
  /**
   * Fetch timeline and automatically derive contact from participants
   * @param {string} id - Timeline ID
   * @param {string} content - Content type (e.g., 'thread')
   * @param {string} title - Timeline title
   * @param {object} contact - (Optional) Manual contact override. If not provided, will auto-derive from timeline participants
   * @param {string} defaultTab - Default tab to show in sidepanel
   * @param {string} expandedEntityId - ID of entity to expand
   */
  async fetchTimeline({ commit, dispatch, rootGetters }, { id, content, title, contact, defaultTab, expandedEntityId, suppressOpenTab, skipTimelinesRefresh }) {
    commit("SET_TIMELINE_LOADING", true)
    commit("SET_ID", id)
    commit("SET_CONTENT", content)
    commit("SET_TITLE", title)
    if (defaultTab) {
      commit("SET_DEFAULT_TAB", defaultTab)
    } else {
      commit("SET_DEFAULT_TAB", 'details')
    }
    commit("SET_EXPANDED_ENTITY_ID", expandedEntityId || null)
    if (!suppressOpenTab) {
      commit("OPEN_TAB", {
        id: `timeline-${id}`,
        type: 'contact',
        title: title || 'Timeline',
        closeable: true,
        innerTab: defaultTab || 'details',
        payload: { id, content, title, contact, defaultTab, expandedEntityId },
      })
    }

    await dispatch('timeline/fetchTimelineStream', id, { root: true })
    const timelineData = rootGetters['timeline/getTimelineById'](id)
    if (timelineData) {
      const derivedContact = contact || deriveContactFromTimeline(timelineData, rootGetters);
      commit("SET_CONTACT", derivedContact)
      commit("SET_SIDE_PANEL_DATA", timelineData)

      if (derivedContact && derivedContact.id && !skipTimelinesRefresh) {
        await dispatch('fetchTimelinesTwo', { id: derivedContact.id })
      }

      dispatch('bodyReady', { id })
      commit("SET_TIMELINE_LOADING", false)
      return timelineData;
    }
    commit("SET_TIMELINE_LOADING", false)
    return false;

  },
  bodyReady({ state, commit, rootGetters }, { id }) {
    if (state.id === id) {
      const timeline = rootGetters['timeline/getTimelineById'](id);
      if (timeline) {
        commit("SET_SIDE_PANEL_DATA", timeline)
        return;
      }

    }
    else {
      return
    }
  },
  updateTimeline({ commit, state }, fetchedTimeline) {
    // Update the timeline in sidepanel if it exists
    if (state.timeline && state.timeline.id === fetchedTimeline.id) {
      commit("SET_SIDE_PANEL_DATA", fetchedTimeline)
    }

    // Also update in timelines array if it exists
    if (state.timelines && state.timelines.items) {
      const timelineIndex = state.timelines.items.findIndex(t => t.id === fetchedTimeline.id);
      if (timelineIndex !== -1) {
        state.timelines.items[timelineIndex] = fetchedTimeline;
      }
    }
  },
  patchEmailBody({ state }, { timelineId, emailId, contentHtml }) {
    // Patch in side-panel active timeline
    if (state.timeline?.id === timelineId) {
      const email = state.timeline.emailMessages?.find(e => e.id === emailId)
      if (email) email.contentHtml = contentHtml
    }
    // Patch in side-panel timelines list
    if (state.timelines?.items) {
      const tl = state.timelines.items.find(t => t.id === timelineId)
      if (tl) {
        const email = tl.emailMessages?.find(e => e.id === emailId)
        if (email) email.contentHtml = contentHtml
      }
    }
  },
  patchTimelineExtras({ state }, { timelineId, extras }) {
    const patch = (tl) => {
      if (!tl) return
      if (extras.notes?.length) tl.notes = extras.notes
      if (extras.tasks?.length) {
        tl.tasks = extras.tasks
        // Sync taskInfo with updated tasks
        if (tl.timelineItems) {
          const taskMap = new Map(extras.tasks.map(t => [t.id, t]))
          tl.timelineItems = tl.timelineItems.map(item => {
            if (item.itemType === 2) {
              const task = taskMap.get(item.id)
              if (task && item.taskInfo) {
                return {
                  ...item,
                  taskInfo: {
                    ...item.taskInfo,
                    isDone: task.completedDate !== null
                  }
                }
              }
            }
            return item
          })
        }
      }
      if (extras.events?.length) tl.events = extras.events
    }
    if (state.timeline?.id === timelineId) patch(state.timeline)
    if (state.timelines?.items) patch(state.timelines.items.find(t => t.id === timelineId))
  },
  async fetchTimelines({ commit, rootGetters, state }, { id, content, title, contact, suppressOpenTab }) {
    commit("SET_TIMELINES_LOADING", true)
    commit("SET_ID", id)
    commit("SET_CONTENT", content)
    commit("SET_TITLE", title)
    commit("SET_CONTACT", contact)
    if (!suppressOpenTab) {
      commit("OPEN_TAB", {
        id: `contact-${id}`,
        type: 'contact',
        title: title || contact?.name || 'Contact',
        closeable: true,
        innerTab: 'details',
        payload: { id, content, title, contact },
      })
    }
    if (title == "ME") {
      const user = rootGetters['user/user'];

      return await api.get(`timeline/${user.email}/mine`, state.requestData).then(response => {
        if (response) {
          commit("SET_TIMELINE", response.data)
          commit("SET_TIMELINES_LOADING", false)
        }
        return false;
      });
    }
    else {
      return await api.get(`timeline-search/listing`, { ...state.requestData, folder: 2 }).then(response => {
        if (response) {
          commit("SET_TIMELINE", response.data)
          commit("SET_TIMELINES_LOADING", false)
        }
        return false;
      });
    }
  },
  async fetchTimelinesTwo({ commit, rootGetters, state }, { id }) {
    commit("SET_TIMELINES_LOADING", true)
    return await api.get(`timeline/contact/${id}`, state.requestData).then(response => {
      if (response) {
        commit("SET_TIMELINE", response.data)
        commit("SET_TIMELINES_LOADING", false)
      }
      return false;
    });

  },
  hideSidePanel({ commit }) {
    commit("HIDE_SIDE_PANEL")
  },
  async markAsRead({ commit, dispatch, state }, request) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    const calculatedRequest = calculateForMarkAsRead(state, request);
    const count = calculatedRequest.ids.length;
    let message = count === 1 ? 'Email read' : `${count} emails read`;
    if (count == 0) {
      message = request.length === 1
        ? 'Email already read'
        : `${request.length} emails already read`;

      setTimeout(() => {
        toast.update(toastId, {
          render: message,
          autoClose: 1000,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      await new Promise(resolve => setTimeout(resolve, 1000));
      return true;
    }
    else {
      try {
        const response = await api.insert(`timeline/markAsRead`, { ids: calculatedRequest.ids });
        if (response) {
          setTimeout(() => {
            toast.update(toastId, {
              render: message,
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
              theme: 'email',
              isLoading: false,
            });
            toast.done(toastId);
          });
          commit("MARK_AS_READ", calculatedRequest);
          dispatch('timeline/markAsReadFromSidePanel', calculatedRequest, { root: true });
          scheduleFetchTimelineCount(dispatch);
          return true;
        }
      } catch (error) {
        setTimeout(() => {
          toast.update(toastId, {
            render: "Failed to change emails flags",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        return true;
      }
    }
  },
  async markAsReadContactId({ commit, dispatch, state, rootGetters }) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    const contact = rootGetters['timeline/getContactById'](state.id);
    const count = contact.unSeenCount;
    let message = count === 1 ? 'Email read' : `${count} emails read`;
    if (count == 0) {
      message = 'All emails already read';

      setTimeout(() => {
        toast.update(toastId, {
          render: message,
          autoClose: 1000,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      await new Promise(resolve => setTimeout(resolve, 1000));
      return true;
    }
    else {
      try {
        const response = await api.insert(`timeline/markAsRead`, { contactId: state.id });
        if (response) {
          setTimeout(() => {
            toast.update(toastId, {
              render: message,
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
              theme: 'email',
              isLoading: false,
            });
            toast.done(toastId);
          });
          commit("MARK_ALL_AS_READ");
          dispatch('timeline/markAllAsReadFromSidePanel', { contactId: state.id, unSeenCount: contact.unSeenCount }, { root: true });
          scheduleFetchTimelineCount(dispatch);
          return true;
        }
      } catch (error) {
        setTimeout(() => {
          toast.update(toastId, {
            render: "Failed to change emails flags",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        return true;
      }
    }
  },
  async markAsUnReadContactId({ commit, dispatch, rootGetters, state }) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    const contact = rootGetters['timeline/getContactById'](state.id);
    const count = contact.totalCount - contact.unSeenCount
    let message = `${count} emails unread`;
    if (count <= 0) {
      message = `all Emails already unread`;
      setTimeout(() => {
        toast.update(toastId, {
          render: message,
          autoClose: 1000,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      await new Promise(resolve => setTimeout(resolve, 1000));
      return true;
    }
    else {
      try {
        const response = await api.insert(`timeline/markAsUnRead`, { contactId: state.id });
        if (response) {
          setTimeout(() => {
            toast.update(toastId, {
              render: message,
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
              theme: 'email',
              isLoading: false,
            });
            toast.done(toastId);
          });
          commit("MARK_ALL_AS_UNREAD");
          dispatch('timeline/markAllAsUnReadFromSidePanel', { contactId: state.id, seenCount: count }, { root: true });
          scheduleFetchTimelineCount(dispatch);
          return true;
        }
      } catch (error) {
        setTimeout(() => {
          toast.update(toastId, {
            render: "Failed to change emails flags",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        return true;
      }
    }
  },
  async markAsUnRead({ commit, dispatch, state }, request) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    const calculatedRequest = calculateForMarkAsUnread(state, request);
    const count = calculatedRequest.ids.length;
    let message = count === 1 ? 'Email unread' : `${count} emails unread`;
    if (count == 0) {
      message = request.length === 1
        ? 'Email already unread'
        : `${request.length} emails already unread`;

      setTimeout(() => {
        toast.update(toastId, {
          render: message,
          autoClose: 1000,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      await new Promise(resolve => setTimeout(resolve, 1000));
      return true;
    }
    else {
      try {
        const response = await api.insert(`timeline/markAsUnRead`, { ids: calculatedRequest.ids });
        if (response) {
          setTimeout(() => {
            toast.update(toastId, {
              render: message,
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
              theme: 'email',
              isLoading: false,
            });
            toast.done(toastId);
          });
          commit("MARK_AS_UNREAD", calculatedRequest);
          dispatch('timeline/markAsUnreadFromSidePanel', calculatedRequest, { root: true });
          scheduleFetchTimelineCount(dispatch);
          return true;
        }
      } catch (error) {
        setTimeout(() => {
          toast.update(toastId, {
            render: "Failed to change emails flags",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        return true;
      }
    }
  },

  async loadContact({ commit, dispatch, rootGetters, state }, id) {
    commit("SET_TIMELINES_LOADING", true)
    const calculateLoadContact = calculateForLoadContact(state, id);
    if (calculateLoadContact) {
      const contact = await api.getById(`contact`, id)
      return dispatch('fetchTimelines', { id: id, content: "content", title: contact.data.name, contact: contact.data });
    }
    else {
      return dispatch('fetchTimelinesTwo', { id: id });
    }
  },
  async markAsImportant({ commit, dispatch, state }, request) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    const calculatedRequest = calculateForMarkAsImportant(state, request);
    const count = calculatedRequest.ids.length;
    let message = count === 1 ? 'Email marked important' : `${count} emails marked important`;
    if (count == 0) {
      message = request.length === 1 ? 'Email already important' : `${request.length} emails already important`;
      setTimeout(() => {
        toast.update(toastId, {
          render: message,
          autoClose: 1000,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      await new Promise(resolve => setTimeout(resolve, 1000));
      return true;
    } else {
      try {
        const response = await api.insert(`timeline/markAsImportant`, { ids: calculatedRequest.ids });
        if (response) {
          setTimeout(() => {
            toast.update(toastId, {
              render: message,
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
              theme: 'email',
              isLoading: false,
            });
            toast.done(toastId);
          });
          commit("MARK_AS_IMPORTANT", calculatedRequest);
          dispatch('timeline/markAsImportantFromSidePanel', calculatedRequest, { root: true });
          scheduleFetchTimelineCount(dispatch);
          return true;
        }
      } catch (error) {
        setTimeout(() => {
          toast.update(toastId, {
            render: "Failed to change emails flags",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        return true;
      }
    }
  },
  async markAsImportantContactId({ commit, dispatch, state }) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    try {
      const response = await api.insert(`timeline/markAsImportant`, { contactId: state.id });
      if (response) {
        setTimeout(() => {
          toast.update(toastId, {
            render: `${response.data} emails marked important`,
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        commit("MARK_ALL_AS_IMPORTANT");
        dispatch('timeline/markAllAsImportantFromSidePanel', response.data, { root: true });
        scheduleFetchTimelineCount(dispatch);
        return true;
      }
    } catch (error) {
      setTimeout(() => {
        toast.update(toastId, {
          render: "Failed to change emails flags",
          autoClose: true,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      return true;
    }

  },
  async markAsNotImportantContactId({ commit, dispatch, state }) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    try {
      const response = await api.insert(`timeline/markAsNotImportant`, { contactId: state.id });
      if (response) {
        setTimeout(() => {
          toast.update(toastId, {
            render: `${response.data} emails marked not important`,
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        commit("MARK_ALL_AS_NOT_IMPORTANT");
        dispatch('timeline/markAllAsNotImportantFromSidePanel', response.data, { root: true });
        scheduleFetchTimelineCount(dispatch);
        return true;
      }
    } catch (error) {
      setTimeout(() => {
        toast.update(toastId, {
          render: "Failed to change emails flags",
          autoClose: true,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      return true;
    }

  },
  async markAsNotImportant({ commit, dispatch, state }, request) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    const calculatedRequest = calculateForMarkAsNotImportant(state, request);
    const count = calculatedRequest.ids.length;
    let message = count === 1 ? 'Email marked not important' : `${count} emails marked not important`;
    if (count == 0) {
      message = request.length === 1 ? 'Email already not important' : `${request.length} emails already not important`;
      setTimeout(() => {
        toast.update(toastId, {
          render: message,
          autoClose: 1000,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      await new Promise(resolve => setTimeout(resolve, 1000));
      return true;
    }
    else {
      try {
        const response = await api.insert(`timeline/markAsNotImportant`, { ids: calculatedRequest.ids });
        if (response) {
          setTimeout(() => {
            toast.update(toastId, {
              render: message,
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
              theme: 'email',
              isLoading: false,
            });
            toast.done(toastId);
          });
          commit("MARK_AS_NOT_IMPORTANT", calculatedRequest);
          dispatch('timeline/markAsNotImportantFromSidePanel', calculatedRequest, { root: true });
          scheduleFetchTimelineCount(dispatch);
          return true;
        }
      } catch (error) {
        setTimeout(() => {
          toast.update(toastId, {
            render: "Failed to change emails flags",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        return true;
      }
    }
  },
  async toggleWaitingOn({ state, commit, dispatch }, request) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    const calculateCountAndUnseen = calculateToggleWaitingOn(state, request);
    let message = request.dueDate ? 'Email sets waiting-on' : "Email sets no waiting";
    try {
      const response = await api.insert(`timeline/toggleWaitingOn`, request);
      if (response) {
        setTimeout(() => {
          toast.update(toastId, {
            render: message,
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        commit("UPDATE_WAITING", request);
        dispatch('timeline/toggleWaitingOnTimelinesFromSidePanel', calculateCountAndUnseen, { root: true });
        scheduleFetchTimelineCount(dispatch);
        return true;
      }
    } catch (error) {
      setTimeout(() => {
        toast.update(toastId, {
          render: error,
          autoClose: true,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      return false;

    }
  },
  async archiveTimeline({ commit, dispatch, state }, request) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    const calculatedRequest = calculateForArchive(state, request);
    const count = calculatedRequest.ids.length;
    let message = count === 1 ? 'Email archived' : `${count} emails archived`;
    if (count == 0) {
      message = request.length === 1
        ? 'Email already archived'
        : `${request.length} emails already archived`;
      setTimeout(() => {
        toast.update(toastId, {
          render: message,
          autoClose: true,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      return true;
    }
    else {
      try {
        const response = await api.insert(`timeline/archive`, { ids: calculatedRequest.ids });
        if (response) {
          setTimeout(() => {
            toast.update(toastId, {
              render: message,
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
              theme: 'email',
              isLoading: false,
            });
            toast.done(toastId);
          });
          commit("MARK_AS_ARCHIVE", calculatedRequest);
          dispatch('timeline/archiveTimelinesFromSidePanel', calculatedRequest, { root: true });
          scheduleFetchContactsFilter(dispatch);
          scheduleFetchTimelineCount(dispatch);
          return true;
        }
      }
      catch (error) {
        setTimeout(() => {
          toast.update(toastId, {
            render: "Failed to change emails folder",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        return true;
      }
    }
  },
  async archiveTimelineContactId({ commit, dispatch, state }, request) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    const count = request.totalCount;
    let message = count === 1 ? 'Email archived' : `${count} emails archived`;

    {
      try {
        const response = await api.insert(`timeline/archive`, { contactId: state.id });
        if (response) {
          setTimeout(() => {
            toast.update(toastId, {
              render: message,
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
              theme: 'email',
              isLoading: false,
            });
            toast.done(toastId);
          });
          commit("MARK_AS_ARCHIVE_All");
          dispatch('timeline/archiveTimelinesFromSidePanelAll', request, { root: true });
          scheduleFetchContactsFilter(dispatch);
          scheduleFetchTimelineCount(dispatch);
          return true;
        }
      }
      catch (error) {
        setTimeout(() => {
          toast.update(toastId, {
            render: "Failed to change emails folder",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        return true;
      }
    }
  },
  async archiveTimelineContactIds({ commit, dispatch, state }, request) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    let count = 0;

    for (const contact of request) {
      count += contact.totalCount;
    }
    let message = count === 1 ? 'Email archived' : `${count} emails archived`;
    {
      try {
        const response = await api.insert(`timeline/archive/contacts`, { contactIds: request.map(contact => contact.id) });
        if (response) {
          setTimeout(() => {
            toast.update(toastId, {
              render: message,
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
              theme: 'email',
              isLoading: false,
            });
            toast.done(toastId);
          });
          dispatch('timeline/archiveTimelinesFromContactFilter', request, { root: true });
          scheduleFetchContactsFilter(dispatch);
          scheduleFetchTimelineCount(dispatch);
          return true;
        }
      }
      catch (error) {
        setTimeout(() => {
          toast.update(toastId, {
            render: "Failed to change emails folder",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        return true;
      }
    }
  },
  async deleteTimeline({ state, commit, dispatch }, request) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    const calculatedRequest = calculateForDelete(state, request);
    const count = calculatedRequest.ids.length;
    let message = count === 1 ? 'Email deleted' : `${count} Emails deleted`;
    if (count == 0) {
      message = "emails already deleted"
      setTimeout(() => {
        toast.update(toastId, {
          render: message,
          autoClose: 1000,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      await new Promise(resolve => setTimeout(resolve, 1000));
      return true;
    }
    else {
      try {

        const response = await api.insert(`timeline/moveToBin`, { ids: calculatedRequest.ids });
        if (response) {
          setTimeout(() => {
            toast.update(toastId, {
              render: message,
              autoClose: true,
              closeOnClick: true,
              closeButton: true,
              theme: 'email',
              isLoading: false,
            });
            toast.done(toastId);
            commit("MOVE_TO_BIN", calculatedRequest);
          });
          dispatch('timeline/deleteTimelinesFromSidePanel', calculatedRequest, { root: true });
          scheduleFetchContactsFilter(dispatch);
          scheduleFetchTimelineCount(dispatch);
          return true;
        }
      } catch (error) {
        setTimeout(() => {
          toast.update(toastId, {
            render: "Failed to delete emails",
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        return true;
      }
    }
  },
  async deleteTimelineContactId({ state, commit, dispatch }) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    try {
      const response = await api.deleteWithoutId(`timeline/contact/${state.id}`);
      if (response) {
        const count = response.data.totalCount
        let message = count === 1 ? 'Email deleted' : `${count} Emails deleted`;
        setTimeout(() => {
          toast.update(toastId, {
            render: message,
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
          commit("MOVE_ALL_TO_BIN");
        });
        dispatch('timeline/deleteTimelinesByContactIdFromSidePanel', { request: response.data, contactId: state.id }, { root: true });
        dispatch('timeline/fetchContactsFilter', null, { root: true });
        return true;
      }
    } catch (error) {
      setTimeout(() => {
        toast.update(toastId, {
          render: "Failed to delete emails",
          autoClose: true,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      return true;
    }
  },
  openTab({ commit }, tabPayload) {
    commit('OPEN_TAB', tabPayload)
  },
  closeTab({ commit }, tabId) {
    commit('CLOSE_TAB', tabId)
  },
  setActiveTab({ commit, state, dispatch }, tabId) {
    commit('SET_ACTIVE_TAB_ID', tabId)
    const tab = state.tabs.find(t => t.id === tabId)
    if (!tab || tab.type === 'default' || tab.type === 'search') return
    if (tab.payload) {
      if (tabId.startsWith('contact-')) {
        if (state.id === tab.payload.id) return
        dispatch('fetchTimelines', { ...tab.payload, suppressOpenTab: true })
      } else if (tabId.startsWith('timeline-')) {
        if (state.id === tab.payload.id) return
        dispatch('fetchTimeline', { ...tab.payload, suppressOpenTab: true })
      }
    }
  },
  setTabInnerTab({ commit }, payload) {
    commit('SET_TAB_INNER_TAB', payload)
  },
  setTabSearchFilter({ commit }, payload) {
    commit('SET_TAB_SEARCH_FILTER', payload)
  },
  setTabExpandedEmail({ commit }, payload) {
    commit('SET_TAB_EXPANDED_EMAIL', payload)
  },
  async deleteTimelineContactIds({ state, commit, dispatch }, selectedContacts) {
    const toastId = toast.loading(
      'Please wait...', {
      theme: 'email',
    });
    try {
      const response = await api.deleteWithBody('timeline/contacts', selectedContacts);
      if (response) {
        const count = response.data.totalCount
        let message = count === 1 ? 'Email deleted' : `${count} Emails deleted`;
        setTimeout(() => {
          toast.update(toastId, {
            render: message,
            autoClose: true,
            closeOnClick: true,
            closeButton: true,
            theme: 'email',
            isLoading: false,
          });
          toast.done(toastId);
        });
        dispatch('timeline/deleteTimelinesByContactIdsFromSidePanel', { request: response.data, contactIds: selectedContacts }, { root: true });
        dispatch('timeline/fetchContactsFilter', null, { root: true });
        return true;
      }
    } catch (error) {
      setTimeout(() => {
        toast.update(toastId, {
          render: "Failed to delete emails",
          autoClose: true,
          closeOnClick: true,
          closeButton: true,
          theme: 'email',
          isLoading: false,
        });
        toast.done(toastId);
      });
      return true;
    }
  }
}
function calculateForArchive(state, request) {
  const timelines = state.timelines.items.filter(item => request.includes(item.id) && !item.isArchive);
  let ids = timelines.map(i => i.id);
  let unSeenCount = 0;
  timelines.forEach(item => {
    if (item.emailMessages) {
      unSeenCount += item.emailMessages.filter(ti => !ti.seen).length;
    }
  });
  let contactId = state.id
  return { ids, unSeenCount, contactId };
}

function calculateForDelete(state, request) {
  const timelines = state.timelines.items.filter(item => request.includes(item.id));
  let ids = timelines.map(i => i.id);

  let unSeenCount = 0;
  if (Array.isArray(timelines)) {
    timelines.forEach(item => {
      if (item.emailMessages && Array.isArray(item.emailMessages)) {
        unSeenCount += item.emailMessages.filter(ti => !ti.seen).length;
      }
    });
  }
  let importantCount = timelines.filter(i => i.isImportant).length;
  let waitingOnCount = timelines.filter(i => i.waitingOn).length;
  let overdueCount = timelines.filter(i => i.dueDate && new Date(i.dueDate) <= new Date()).length;
  let contactId = state.id

  return { ids, unSeenCount, importantCount, waitingOnCount, overdueCount, contactId };
}
function calculateForMarkAsRead(state, request) {
  const timelinesInbox = state.timelines.items.filter(item => request.includes(item.id) && !item.seen);
  let ids = timelinesInbox.map(i => i.id);
  let inboxCount = 0;
  timelinesInbox.forEach(item => {
    if (item.emailMessages) {
      inboxCount += item.emailMessages.filter(ti => !ti.seen).length;
    }
  });
  let contactId = state.id
  return { ids, inboxCount, contactId };
}
function calculateForMarkAsUnread(state, request) {
  const timelinesInbox = state.timelines.items.filter(item => request.includes(item.id) && item.seen);
  let ids = timelinesInbox.map(i => i.id);
  let inboxCount = 0;
  timelinesInbox.forEach(item => {
    if (item.emailMessages) {
      inboxCount += item.emailMessages.filter(ti => ti.seen).length;
    }
  });
  let contactId = state.id
  return { ids, inboxCount, contactId };
}

function calculateForLoadContact(state, id) {
  if (state.id === id) {
    return false;
  }
  else {
    return true;
  }
}
function calculateForMarkAsNotImportant(state, request) {
  const importantTimelines = state.timelines.items.filter(item => request.includes(item.id) && item.isImportant);
  let ids = importantTimelines.map(i => i.id);
  return { ids };
}
function calculateForMarkAsImportant(state, request) {
  const importantTimelines = state.timelines.items.filter(item => request.includes(item.id) && !item.isImportant);
  let ids = importantTimelines.map(i => i.id);
  return { ids };
}
function calculateToggleWaitingOn(s, request) {
  const timeline = s.timelines.items.find(t => t.id === request.timelineId);
  if (!timeline) return { addWaitingOn: false, addOverDue: false, removeOverDue: false };
  let addWaitingOn = !timeline.waitingOn;
  let addOverDue = false;
  let removeOverDue = false;
  const currentDateTime = new Date();
  const dueDateTime = request.dueDate ? new Date(request.dueDate) : null;
  const wasOverDue = timeline.dueDate && new Date(timeline.dueDate) <= currentDateTime;

  if (dueDateTime) {
    if (addWaitingOn) {
      addOverDue = dueDateTime <= currentDateTime;
    } else {
      if (dueDateTime > currentDateTime) {
        removeOverDue = true;
      }
    }
  } else {
    removeOverDue = wasOverDue;
  }
  return { addWaitingOn, addOverDue, removeOverDue };
}

export const mutations = {
  SET_PANEL_OPEN(s, val) {
    s.panelOpen = val
  },
  SET_PANEL_WIDTH(s, val) {
    s.panelWidth = val
  },
  SET_CONTACT_ALL(s, data) {
    s.contactAll = data
  },
  SET_CONTACT_ALL_LOADING(s, isLoading) {
    s.contactAllIsLoading = isLoading
  },
  SET_CONTACT_ALL_PAGE_SIZE(s, pageSize) {
    s.contactAllRequestData.pageSize = pageSize
  },
  SET_CONTACT_ALL_PAGE(s, page) {
    s.contactAllRequestData.page = page
  },
  SET_CONTACT_ALL_PAGE_ORDER(s, pageOrder) {
    s.contactAllRequestData.order = pageOrder
  },
  SET_EMAIL_ANALYSIS(s, { timelineId, data }) {
    s.emailAnalyses = { ...s.emailAnalyses, [timelineId]: data }
  },
  SET_CHAT_LOADING(s, val) {
    s.chatLoading = val
  },
  APPEND_CHAT_MESSAGE(s, { timelineId, message }) {
    const existing = s.chatMessages[timelineId] || []
    s.chatMessages = { ...s.chatMessages, [timelineId]: [...existing, message] }
  },
  SET_EMAIL_ANALYSIS_LOADING(s, val) {
    s.emailAnalysisLoading = val
  },
  SET_ACTIVE_ANALYSIS_TIMELINE(s, id) {
    s.activeAnalysisTimelineId = id
  },
  SET_AUTO_ANALYZE_TIMELINE(s, id) {
    s.autoAnalyzeTimelineId = id
  },
  SET_ACTIVE_EMAIL_BODY(s, body) {
    s.activeEmailBody = body
  },
  SET_DEFAULT_TAB(s, tab) {
    s.defaultTab = tab
  },
  OPEN_TAB(s, tab) {
    const MAX = 10
    const idx = s.tabs.findIndex(t => t.id === tab.id)
    if (idx !== -1) {
      const updated = { ...s.tabs[idx], title: tab.title }
      if (tab.innerTab) updated.innerTab = tab.innerTab
      if (tab.query !== undefined) updated.query = tab.query
      s.tabs.splice(idx, 1, updated)
      s.activeTabId = tab.id
      return
    }
    s.tabs.push(tab)
    s.activeTabId = tab.id
    const dynamic = s.tabs.filter(t => t.id !== 'default')
    if (dynamic.length > MAX) {
      const toRemove = dynamic[0].id
      s.tabs = s.tabs.filter(t => t.id !== toRemove)
    }
  },
  CLOSE_TAB(s, tabId) {
    const idx = s.tabs.findIndex(t => t.id === tabId)
    if (idx === -1 || s.tabs[idx].id === 'default') return
    s.tabs.splice(idx, 1)
    if (s.activeTabId === tabId) {
      const newIdx = Math.max(0, idx - 1)
      s.activeTabId = s.tabs[newIdx]?.id || 'default'
    }
  },
  SET_ACTIVE_TAB_ID(s, tabId) {
    s.activeTabId = tabId
  },
  SET_TAB_INNER_TAB(s, { tabId, innerTab }) {
    const idx = s.tabs.findIndex(t => t.id === tabId)
    if (idx !== -1) {
      s.tabs.splice(idx, 1, { ...s.tabs[idx], innerTab })
    }
  },
  SET_TAB_SEARCH_FILTER(s, { tabId, filter }) {
    const idx = s.tabs.findIndex(t => t.id === tabId)
    if (idx !== -1) {
      s.tabs.splice(idx, 1, { ...s.tabs[idx], searchFilter: filter })
    }
  },
  SET_TAB_EXPANDED_EMAIL(s, { tabId, emailId }) {
    const idx = s.tabs.findIndex(t => t.id === tabId)
    if (idx !== -1) {
      s.tabs.splice(idx, 1, { ...s.tabs[idx], expandedEmailId: emailId })
    }
  },
  RESET_TABS(s) {
    s.tabs = [{ id: 'default', type: 'default', title: 'Notification', closeable: false }]
    s.activeTabId = 'default'
  },
  SET_EXPANDED_ENTITY_ID(s, entityId) {
    s.expandedEntityId = entityId
  },
  REMOVE(s, ids) {
    s.timelines.items = s.timelines.items.filter(item => !ids.includes(item.id));
  },
  MOVE_TO_BIN(s, request) {
    s.timelines.items = s.timelines.items.filter(i => !request.ids.some(id => id === i.id));
    s.timelines.totalCount -= request.ids.length
  },
  MOVE_ALL_TO_BIN(s) {
    s.timelines.items = [];
    s.timelines.totalCount = 0;
  },
  MARK_AS_READ(s, request) {
    request.ids.forEach(id => {
      const timeline = s.timelines.items.find(t => t.id === id);
      if (timeline) {
        timeline.emailMessages.forEach(e => e.seen = true);
        timeline.seen = true;
      }
    })
  },
  MARK_ALL_AS_READ(s) {
    s.timelines.items.forEach(timeline => {
      if (Array.isArray(timeline.emailMessages)) {
        timeline.emailMessages.forEach(e => e.seen = true);
      }
      timeline.seen = true;
    });
  },
  MARK_ALL_AS_UNREAD(s) {
    s.timelines.items.forEach(timeline => {
      if (Array.isArray(timeline.emailMessages)) {
        timeline.emailMessages.forEach(e => e.seen = false);
      }
      timeline.seen = false;
    });
  },
  MARK_AS_UNREAD(s, request) {
    request.ids.forEach(id => {
      const timeline = s.timelines.items.find(t => t.id === id);
      if (timeline) {
        timeline.emailMessages.forEach(e => e.seen = false);
        timeline.seen = false;
      }
    })
  },
  MARK_AS_ARCHIVE(s, request) {
    s.timelines.items = s.timelines.items.filter(i => !request.ids.some(id => id === i.id));
    s.timelines.totalCount -= request.ids.length
  },
  MARK_AS_ARCHIVE_All(s) {
    s.timelines.items = [];
    s.timelines.totalCount = 0
  },
  SHOW_SIDE_PANEL(x) {
    x.show = true
  },
  SET_CONTENT(x, content) {
    x.content = content
  },
  SET_ID(s, id) {
    s.id = id
    s.requestData.contactId = id
  },
  SET_TITLE(x, title) {
    x.title = title
  },
  SET_CONTACT(x, contact) {
    x.contact = contact
  },
  SET_TIMELINE(x, timelines) {
    x.timelines = timelines
  },
  SET_SIDE_PANEL_DATA(x, timeline) {
    // Sync taskInfo with tasks array to ensure consistency
    if (timeline.timelineItems && timeline.tasks) {
      const taskMap = new Map(timeline.tasks.map(t => [t.id, t]))
      timeline.timelineItems = timeline.timelineItems.map(item => {
        if (item.itemType === 2) {
          const task = taskMap.get(item.id)
          if (task && item.taskInfo) {
            return {
              ...item,
              taskInfo: {
                ...item.taskInfo,
                isDone: task.completedDate !== null
              }
            }
          }
        }
        return item
      })
    }
    x.timeline = timeline
  },
  HIDE_SIDE_PANEL(x) {
    x.show = false
  },
  SET_TIMELINES_LOADING(s, isLoading) {
    s.timelinesIsLoading = isLoading;
  },
  SET_TIMELINE_LOADING(s, isLoading) {
    s.timelineIsLoading = isLoading;
  },
  CHANGE_PAGE_SIZE(s, pageSize) {
    s.requestData.pageSize = pageSize
    localStorage.setItem('pageSize_contactFilter', pageSize)
  },
  ADD_TASK(s, task) {
    if (s.show == true && s.id) {
      if (s.timeline.id == task.timelineId) {
        s.timeline.timelineItems.push({
          id: task.id,
          assignDate: task.createDate,
          isDeleted: task.isDeleted,
          isImportant: task.isImportant,
          itemType: 2,
          timelineId: task.timelineId,
          title: task.title
        })
        s.timeline.tasks.push(task);
        s.timeline.taskCount++;
      }
    }
  },
  DELETE_TIMELINE_ITEMS(s, request) {
    if (s.show == true && s.id === request.timelineId) {
      if (Array.isArray(s.timeline.timelineItems)) {
        const itemIdx = s.timeline.timelineItems.findIndex(item => item.id === request.itemId);
        if (itemIdx !== -1) s.timeline.timelineItems.splice(itemIdx, 1);
      }
      switch (request.itemType) {
        case 'notes':
          if (Array.isArray(s.timeline.notes)) {
            const noteIdx = s.timeline.notes.findIndex(e => e.id === request.itemId);
            if (noteIdx !== -1) s.timeline.notes.splice(noteIdx, 1);
            if ('noteCount' in s.timeline) s.timeline.noteCount = s.timeline.notes.length;

          }
          break;

        case 'events':
          if (Array.isArray(s.timeline.events)) {
            const eventIdx = s.timeline.events.findIndex(e => e.id === request.itemId);
            if (eventIdx !== -1) s.timeline.events.splice(eventIdx, 1);
            if ('reminderCount' in s.timeline) s.timeline.reminderCount = s.timeline.events.length;
          }
          break;

        case 'tasks':
          if (Array.isArray(s.timeline.tasks)) {
            const taskIdx = s.timeline.tasks.findIndex(t => t.id === request.itemId);
            if (taskIdx !== -1) s.timeline.tasks.splice(taskIdx, 1);
            if ('taskCount' in s.timeline) s.timeline.taskCount = s.timeline.tasks.length;
          }
          break;

        default:
          break;
      }
    }
  }, EDIT_TASK(s, task) {
    if (s.timeline && s.timeline.id === task.timelineId) {
      // Update timelineItems in s.timeline
      const itemIdx = s.timeline.timelineItems.findIndex(item => item.id === task.id);
      if (itemIdx !== -1) {
        const existingItem = s.timeline.timelineItems[itemIdx];
        // Map string status to TaskStatus enum value
        let statusValue = 1; // None = 1 << 0
        if (task.status === 'done' || task.status === 2 || task.status === (1 << 1)) {
          statusValue = 2; // Done = 1 << 1
        } else if (task.status === 'waitingon' || task.status === 4 || task.status === (1 << 2)) {
          statusValue = 4; // WaitingOn = 1 << 2
        } else if (task.status === 'someday' || task.status === 8 || task.status === (1 << 3)) {
          statusValue = 8; // SomeDay = 1 << 3
        }
        const newItem = {
          ...existingItem,
          id: task.id,
          isImportant: task.isImportant,
          itemType: 2,
          timelineId: task.timelineId,
          title: task.title,
          content: task.content,
          taskInfo: {
            dueDate: task.dueDate,
            isDone: task.completedDate !== null,
            status: statusValue
          }
        };
        // Create new array to ensure Vue detects the change
        s.timeline.timelineItems = s.timeline.timelineItems.map((item, idx) =>
          idx === itemIdx ? newItem : item
        );
      }
      // Update task in tasks array in s.timeline
      const taskIdx = s.timeline.tasks.findIndex(t => t.id === task.id);
      if (taskIdx !== -1) {
        s.timeline.tasks[taskIdx] = task;
      }
      // No count increment, just edit
      return;
    }
  },
  ADD_NOTE(s, note) {
    if (s.show == true && s.id) {
      if (s.timeline.id == note.timelineId) {
        s.timeline.timelineItems.push({
          id: note.id,
          assignDate: note.createDate,
          isDeleted: note.isDeleted,
          isImportant: note.isImportant,
          itemType: 4,
          timelineId: note.timelineId,
          title: note.title
        })
        s.timeline.notes.push(note);
        s.timeline.noteCount++;
      }
    }

  },
  ADD_EMAIL(s, email) {
    if (s.show == true && s.timeline && s.timeline.id == email.timelineId) {
      const sharedId = crypto.randomUUID();
      const now = new Date();
      const rawEmail = toRaw(email);

      s.timeline.timelineItems.push({
        id: sharedId,
        timelineId: rawEmail.timelineId,
        assignDate: now,
        itemType: 1,
        title: rawEmail.subject,
        isDeleted: false,
        seen: true,
        mainFolder: 0,
        newlyAdded: true,
      });

      if (!s.timeline.emailMessages) s.timeline.emailMessages = [];
      s.timeline.emailMessages.push({
        id: sharedId,
        timelineId: rawEmail.timelineId,
        subject: rawEmail.subject,
        contentHtml: rawEmail.body,
        messageId: rawEmail.messageId || '',
        isImportant: rawEmail.isImportant || false,
        mainFolder: 4,
        senders: rawEmail.fromAddress ? `${rawEmail.fromAddress.name} <${rawEmail.fromAddress.emailAddress}>` : '',
        recipientsTo: rawEmail.toAddresses ? rawEmail.toAddresses.map(a => `${a.name} <${a.emailAddress}>`).join(';') : '',
        recipientsCc: rawEmail.ccAddresses ? rawEmail.ccAddresses.map(a => `${a.name} <${a.emailAddress}>`).join(';') : '',
        recipientsBcc: rawEmail.bccAddresses ? rawEmail.bccAddresses.map(a => `${a.name} <${a.emailAddress}>`).join(';') : '',
        attachments: rawEmail.attachments ? [...rawEmail.attachments] : [],
        assignDate: now.toISOString(),
      });

      s.timeline.emailCount = (s.timeline.emailCount || 0) + 1;
    }
  },
  EDIT_NOTE(s, note) {
    // If in side panel context, update s.timeline if it matches
    if (s.timeline && s.timeline.id === note.timelineId) {
      // Update timelineItems in s.timeline
      const itemIdx = s.timeline.timelineItems.findIndex(item => item.id === note.id && item.itemType === 4);
      if (itemIdx !== -1) {
        s.timeline.timelineItems[itemIdx] = {
          id: note.id,
          isImportant: note.isImportant,
          itemType: 4,
          timelineId: note.timelineId,
          title: note.title,
          content: note.content
        };
      }
      // Update note in notes array in s.timeline
      const noteIdx = s.timeline.notes.findIndex(n => n.id === note.id);
      if (noteIdx !== -1) {
        s.timeline.notes[noteIdx] = note;
      }
      // No count increment, just edit
      return;
    }
    // Otherwise, update in s.timelines.items
  },
  ADD_EVENT(s, newEvent) {
    const event = newEvent.data[0]
    let stDate = new Date(event.start)
    let enDate = new Date(event.end)
    let dNoTime = new Date(event.start)
    if (s.show == true && s.id) {
      if (s.timeline.id == event.timelineId) {
        s.timeline.timelineItems.push({
          id: event.id,
          assignDate: event.createDate,
          isDeleted: event.isDeleted,
          isImportant: event.isImportant,
          itemType: 3,
          timelineId: event.timelineId,
          title: event.summary,
          startDateTime: stDate,
          endDateTime: enDate,
          dateNoTime: dNoTime
        })
        s.timeline.events.push(event);
        s.timeline.eventCount++;
      }
    }
  },
  EDIT_EVENT(s, newEvent) {
    const event = newEvent;
    let stDate = new Date(event.start);
    let enDate = new Date(event.end);
    let dNoTime = new Date(event.start);
    if (s.timeline && s.timeline.id == event.timelineId) {
      const itemIdx = s.timeline.timelineItems.findIndex(item => item.id === event.id && item.itemType === 3);
      if (itemIdx !== -1) {
        s.timeline.timelineItems[itemIdx] = {
          id: event.id,
          assignDate: event.createDate,
          isDeleted: event.isDeleted,
          isImportant: event.isImportant,
          itemType: 3,
          timelineId: event.timelineId,
          title: event.summary,
          startDateTime: stDate,
          endDateTime: enDate,
          dateNoTime: dNoTime
        };
      }
      const eventIdx = s.timeline.events.findIndex(e => e.id === event.id);
      if (eventIdx !== -1) {
        s.timeline.events[eventIdx] = event;
      }
    }
  },
  CHANGE_PAGE(s, page) {
    s.requestData.page = page
  },
  CHANGE_PAGE_ORDER(s, pageOrder) {
    s.requestData.order = pageOrder
  },
  SEARCH(s, search) {
    s.requestData.search = search
  },
  RESET_SEARCH(s) {
    s.requestData.search = ''
  },
  SET_ENTITY_ID(s, entityId) {
    s.entityId = entityId;
  },
  UPDATE_IMPORTANT(s, data) {
    data.response.forEach(response => {
      const timeline = s.timelines.items.find(t => t.id === response.id);
      if (timeline) {
        timeline.isImportant = data.important;
      }
    })
  },

  SET_ISCOLLAPSE(s, request) {
    const index = s.timelines.items.findIndex(item => item.id === request.id);
    if (index !== -1) {
      s.timelines.items[index].isCollapsed = !s.timelines.items[index].isCollapsed;

    };

  },
  SET_ISCOLLAPSE_TRUE_All(state) {
    state.timelines.items.forEach((timeline) => {
      timeline.isCollapsed = true;
    });
  },
  SET_COUNT_OP(s, { op, model }) {
    const { ids, unSeenCount, seenCount } = model;
    switch (op) {
      case 'archive':
        s.timelines = s.timelines.items.filter(i => !ids.some(id => id === i.id));
        s.contact.totalCount -= ids.length;
        s.contact.unSeenCount -= unSeenCount;
        break;
      case 'moveToBin':
        s.timelines = s.timelines.items.filter(i => !ids.some(id => id === i.id));
        s.contact.totalCount -= ids.length;
        s.contact.unSeenCount -= unSeenCount;
        break;
      case 'markAsImportant':
        ids.forEach(id => {
          const timeline = s.timelines.items.find(t => t.id === id);
          if (timeline) {
            timeline.isImportant = true;
          }
        })
        break;
      case 'markAsNotImportant':
        ids.forEach(id => {
          const timeline = s.timelines.items.find(t => t.id === id);
          if (timeline) {
            timeline.isImportant = false;
          }
        })
        break;
      case 'markAsRead':
        s.contact.unSeenCount -= seenCount;
        ids.forEach(id => {
          const timeline = s.timelines.items.find(t => t.id === id);
          if (timeline) {
            timeline.emailMessages.forEach(e => e.seen = true);
            timeline.seen = true;
          }
        })
        break;
      case 'markAsUnread':
        s.contact.unSeenCount += unSeenCount;
        ids.forEach(id => {
          const timeline = s.timelines.items.find(t => t.id === id);
          if (timeline) {
            timeline.emailMessages.forEach(e => e.seen = false);
            timeline.seen = false;
          }
        })
        break;
    }
  },
  MARK_AS_IMPORTANT(s, request) {
    request.ids.forEach(id => {
      const timeline = s.timelines.items.find(t => t.id === id);
      if (timeline) {
        timeline.isImportant = true;
      }
    })
  },
  MARK_ALL_AS_IMPORTANT(s) {
    s.timelines.items.forEach(timeline => {
      timeline.isImportant = true;
    });
  },
  MARK_ALL_AS_NOT_IMPORTANT(s) {
    s.timelines.items.forEach(timeline => {
      timeline.isImportant = false;
    });
  },
  MARK_AS_NOT_IMPORTANT(s, request) {
    request.ids.forEach(id => {
      const timeline = s.timelines.items.find(t => t.id === id);
      if (timeline) {
        timeline.isImportant = false;
      }
    })
  },
  UPDATE_WAITING(s, request) {
    const timeline = s.timelines.items.find(t => t.id === request.timelineId);
    if (timeline) {
      timeline.waitingOn = !timeline.waitingOn;
      timeline.dueDate = request.dueDate
    }
  },
}

/**
 * Helper function to derive contact from timeline participants
 * Returns the first participant that is not the current user
 */
function deriveContactFromTimeline(timeline, rootGetters) {
  if (!timeline || !timeline.participants || timeline.participants.length === 0) {
    return null;
  }
  
  const user = rootGetters['user/user'];
  const userEmail = user?.email?.toLowerCase();
  
  // Filter out current user from participants
  const otherParticipants = timeline.participants.filter(
    p => p.email?.toLowerCase() !== userEmail
  );
  
  // Get the first participant (or the only participant if it's a self-email)
  const participant = otherParticipants.length > 0 
    ? otherParticipants[0] 
    : timeline.participants[0];
  
  if (!participant || !participant.id) {
    return null;
  }
  
  // Try to get the full contact from contacts store
  const fullContact = rootGetters['contacts/contact'](participant.id);
  
  // Return full contact if available, otherwise return participant data
  return fullContact || participant;
}

export default {
  state,
  getters,
  actions,
  mutations
}